import queryString from "query-string";
import AxiosInstance, { takeLatestRequest } from "@/config/AxiosInstance";
import { API_BASE_URL_ADMIN } from "@/config/appConfig";

const READONLY_BASE = `${API_BASE_URL_ADMIN}/readonly`;

type CampaignOverviewRequest = Record<string, unknown>;
type AxiosResponseShape = { data: unknown };

export const campaignOverviewService = {
  getDigitalCampaigns(data: CampaignOverviewRequest, isSWR = false) {
    const config = {
      method: "get",
      url: `${READONLY_BASE}/launchCampaignReportListing`,
      params: data,
    };
    if (isSWR) {
      return takeLatestRequest(config, "digitalCampaignOverview").then(
        (r: AxiosResponseShape) => r.data
      );
    }
    return takeLatestRequest(config, "digitalCampaignOverview");
  },

  getDirectMailCampaigns(data: CampaignOverviewRequest, isSWR = false) {
    const config = {
      method: "get",
      url: `${READONLY_BASE}/launchPostcardReportListing`,
      params: data,
    };
    if (isSWR) {
      return takeLatestRequest(config, "directMailCampaignOverview").then(
        (r: AxiosResponseShape) => r.data
      );
    }
    return takeLatestRequest(config, "directMailCampaignOverview");
  },

  getFilterParticipants(data: CampaignOverviewRequest, isSWR = false) {
    const query = queryString.stringify(data);
    const url = `${READONLY_BASE}/campaign-filters/participants?${query}`;
    return isSWR
      ? AxiosInstance.get(url).then((r: AxiosResponseShape) => r.data)
      : AxiosInstance.get(url);
  },
};
